import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import { CommodityType } from "../../../models/CommodityType";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  commodityTypes: CommodityType[];
  setCommodityType: (commodityType: CommodityType) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  commodityTypes,
  setCommodityType,
  setShowModal,
  showContextMenu,
}: Props) => {
  const rows: CommodityType[] = commodityTypes.map(
    (commodityType: CommodityType) => ({
      ...commodityType,
    }),
  );

  const columnDefs: ColDef[] = [
    {
      field: "CommodityTypeName",
      headerName: "Name",
      minWidth: 20,
      flex: 2,
      cellStyle: cellStyle,
    },
    {
      field: "IsActive",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setCommodityType,
        data: params.data as CommodityType,
        setShowModal: setShowModal,
        edit: false,
        del: !(params.data as CommodityType).IsSystemType,
        showContextMenu: () =>
          showContextMenu(event, params.data, "commodityTypeContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 150,
      filter: false,
      autoHeaderHeight: true,
    },
  ];
  return { rows, columnDefs };
};
